import { render, staticRenderFns } from "./MoleculeBuildingSpaceSwitchFloorV2.vue?vue&type=template&id=fe6c5998&"
import script from "./MoleculeBuildingSpaceSwitchFloorV2.vue?vue&type=script&lang=js&"
export * from "./MoleculeBuildingSpaceSwitchFloorV2.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeBuildingSpaceSwitchFloorV2.vue?vue&type=style&index=0&id=fe6c5998&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingSpaceSwitchFloor.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeBuildingSpaceSwitchFloorV2.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomInfoPopup: require('/app/components/atoms/common/AtomInfoPopup.vue').default})
